var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostoffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.a,.c{fill-rule:evenodd;}.b,.c{stroke:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 19,
    height: 15,
    rx: 1,
    transform: "translate(1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11,.707,2.061,9.646a.5.5,0,0,0,.354.854H19.586a.5.5,0,0,0,.354-.854Z",
    transform: "translate(22 11) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.99,8.2,2.172,14.636a.5.5,0,0,0,.343.864h16.97a.5.5,0,0,0,.343-.864L13.01,8.2,11,10.207Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostoffice);
export default __webpack_public_path__ + "static/media/postoffice.f4cb2c2ed4d33623e4bbe40b95617581.svg";
export { ForwardRef as ReactComponent };